"use client";

type Queue = ((...args: unknown[]) => void) & { q?: unknown[][] };
declare global { interface Window { oaiq?: Queue } }
let initialized = false;
let configuredPixel = "";
let lastPage = "";
function command(...args: unknown[]): void {
  try { window.oaiq?.(...args); } catch { /* Measurement must never interrupt a successful user action. */ }
}
export function measurementConsent(): boolean {
  try { return window.localStorage.getItem("hf_cookie_consent") === "accepted"; }
  catch { return false; }
}
export function configureOpenAIMeasurement(pixelId: string): void {
  configuredPixel = /^[a-zA-Z0-9_-]{6,100}$/.test(pixelId) ? pixelId : "";
}
export function syncOpenAIConsent(): void {
  if (!measurementConsent()) { command("consent", false); lastPage = ""; return; }
  if (!configuredPixel) return;
  if (!initialized) {
    if (!window.oaiq) {
      const queue: Queue = (...args) => { queue.q!.push(args); };
      queue.q = []; window.oaiq = queue;
      const script = document.createElement("script");
      script.async = true; script.src = "https://bzrcdn.openai.com/sdk/oaiq.min.js";
      document.head.appendChild(script);
    }
    command("consent", true);
    command("init", { pixelId: configuredPixel });
    initialized = true;
  } else command("consent", true);
}
export function measureOpenAIPage(path: string): void {
  if (!measurementConsent() || !initialized || path === lastPage) return;
  if (/(?:^|\/)(?:ad-preview|reklam-onizleme)(?:\/|$)/.test(path)) return;
  lastPage = path;
  command("measure", "page_viewed", { type: "contents" }, { opt_out: true });
}
/** Only successful actions; never forward form fields, arbitrary params or invented revenue. */
export function measureOpenAIAction(action: string): void {
  if (!measurementConsent()) return;
  syncOpenAIConsent();
  if (!initialized) return;
  const standard: Record<string, string> = {
    registration_completed: "registration_completed", contact_submitted: "lead_created",
    inquiry_created: "lead_created", call_request_submit: "lead_created",
  };
  if (standard[action]) {
    command("measure", standard[action], { type: "customer_action" }, { opt_out: true });
  } else if (["newsletter_signup", "price_alert_created"].includes(action)) {
    command("measure", "custom", { type: "custom" }, { custom_event_name: action, opt_out: true });
  }
}
